var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_109",
    "data-name": "Rettangolo 109",
    width: 512,
    height: 512,
    transform: "translate(4760)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_277",
    "data-name": "Raggruppa 277",
    transform: "translate(-5913 -9377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_273",
    "data-name": "Raggruppa 273",
    transform: "translate(1153 9377)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_769",
    "data-name": "Tracciato 769",
    d: "M4760,256c0,104.82,63.07,194.89,153.29,234.476-.76-17.881-.15-39.345,4.42-58.792,4.94-20.771,32.94-139.5,32.94-139.5s-8.19-16.346-8.19-40.489c0-37.96,22-66.288,49.37-66.288,23.3,0,34.56,17.49,34.56,38.442,0,23.421-14.94,58.431-22.61,90.853-6.41,27.153,13.6,49.279,40.4,49.279,48.49,0,81.16-62.254,81.16-136.1,0-56.082-37.78-98.077-106.51-98.077-77.67,0-126.04,57.919-126.04,122.582,0,22.306,6.59,38.05,16.85,50.212,4.76,5.6,5.42,7.857,3.71,14.3-1.21,4.666-4.04,16.045-5.21,20.531-1.72,6.472-6.95,8.79-12.82,6.412-35.77-14.63-52.42-53.8-52.42-97.806,0-72.73,61.3-159.94,182.94-159.94,97.75,0,162.08,70.743,162.08,146.664,0,100.425-55.84,175.443-138.14,175.443-27.64,0-53.62-14.931-62.53-31.909,0,0-14.87,58.972-18.03,70.381-5.39,19.718-16.05,39.436-25.74,54.819A255.28,255.28,0,0,0,5016.03,512C5157.4,512,5272,397.366,5272,256c0-141.4-114.6-256-255.97-256C4874.63,0,4760,114.6,4760,256Z",
    fill: "#cc2127",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.75582e9d7c3e6762c740ce135f59ea13.svg";
export { ForwardRef as ReactComponent };